module.exports = __webpack_public_path__ + "img/switch-gender-male.bd7f1da7.svg";